module.exports = __webpack_public_path__ + "static/media/gallupFieldCap.612f7b5f.csv";